export default `
    # if (data.height) { #
        <div class="tree-view-component #= data.classes #" style="height:#= data.height #px;overflow:auto;">
            <div id="#= data.id || "" #"></div>
        </div>
    # } else if (data.minHeight) { #
        <div class="tree-view-component #= data.classes #"" style="min-height:#= data.minHeight #px;">
            <div id="#= data.id || "" #"></div>
        </div>
    # } else { #
        <div class="tree-view-component #= data.classes #"">
            <div id="#= data.id || "" #"></div>
        </div>
    # } #
`;
